import { c as _c } from "react/compiler-runtime";
import { Flag, Tooltip } from 'platform/components';
import { Box, HStack } from 'platform/foundation-tw';
import { isNil } from 'ramda';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getItemTooltipProps } from '../../utils/getItemTooltipProps';
import { getTooltipProps } from '../../utils/getTooltipProps';

// API shape: row[key].value is an array of these
type TagValue = {
  label: string;
  style?: {
    flagColor?: string;
    flagSubtle?: boolean;
  };
} | null;
type TagCellRendererProps = CellRendererProps<Array<TagValue> | TagValue> & {
  getTooltipProps?: TooltipGetter;
};
export function TagCellRenderer(props) {
  const $ = _c(27);
  let T0;
  let T1;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== props.column?.wrapText || $[1] !== props.getTooltipProps || $[2] !== props.row || $[3] !== props.value) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);
      if (isNil(props.value)) {
        t5 = null;
        break bb0;
      }
      if (!Array.isArray(props.value)) {
        const singleValue = props.value as TagValue;
        if (isNil(singleValue)) {
          t5 = null;
          break bb0;
        }
        const t6 = singleValue.style?.flagColor as never;
        const t7 = singleValue.style?.flagSubtle ?? false;
        const t8 = `tag-cell-renderer-${singleValue.label}`;
        let t9;
        if ($[12] !== singleValue.label || $[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
          t9 = <Flag colorScheme={t6} isSubtle={t7} label={singleValue.label} data-testid={t8} />;
          $[12] = singleValue.label;
          $[13] = t6;
          $[14] = t7;
          $[15] = t8;
          $[16] = t9;
        } else {
          t9 = $[16];
        }
        t5 = <Tooltip {...tooltipProps}>{t9}</Tooltip>;
        break bb0;
      }
      T1 = Box;
      t3 = 1;
      t4 = 1;
      T0 = HStack;
      t0 = 1;
      t1 = props.column?.wrapText;
      t2 = props.value.map((item, index) => {
        if (isNil(item)) {
          return null;
        }
        return <Tooltip {...getItemTooltipProps(index, tooltipProps)} key={index}><Flag colorScheme={item.style?.flagColor as never} isSubtle={item.style?.flagSubtle ?? false} label={item.label} data-testid={`tag-cell-renderer-${item.label}`} /></Tooltip>;
      });
    }
    $[0] = props.column?.wrapText;
    $[1] = props.getTooltipProps;
    $[2] = props.row;
    $[3] = props.value;
    $[4] = T0;
    $[5] = T1;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    T0 = $[4];
    T1 = $[5];
    t0 = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[17] !== T0 || $[18] !== t0 || $[19] !== t1 || $[20] !== t2) {
    t6 = <T0 spacing={t0} wrap={t1}>{t2}</T0>;
    $[17] = T0;
    $[18] = t0;
    $[19] = t1;
    $[20] = t2;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== T1 || $[23] !== t3 || $[24] !== t4 || $[25] !== t6) {
    t7 = <T1 paddingVertical={t3} paddingRight={t4}>{t6}</T1>;
    $[22] = T1;
    $[23] = t3;
    $[24] = t4;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}